import { useState } from 'react';
import { Card } from './ui/card';
import { Upload, Users, Handshake, Wrench } from 'lucide-react';
import DataImportDialog from './import/DataImportDialog';
import { IMPORT_TYPES } from '../utils/importTypes';

const ICONS = { customers: Users, vendors: Handshake, equipment: Wrench };

export default function DataImportSettings() {
  const [kind, setKind] = useState(null);
  return (
    <Card className="p-6" data-testid="data-import-settings">
      <div className="flex items-start gap-3 mb-4">
        <Upload size={20} className="text-slate-400 mt-0.5" />
        <div>
          <h3 className="text-lg font-bold text-slate-900">Data Import</h3>
          <p className="text-sm text-slate-600">Bulk-load lists from a CSV file or pasted spreadsheet rows. You&apos;ll map the columns and review every row before anything is saved.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {Object.entries(IMPORT_TYPES).map(([key, cfg]) => {
          const Icon = ICONS[key];
          return (
            <button key={key} type="button" onClick={() => setKind(key)}
              className="text-left rounded-md border border-slate-200 p-4 hover:border-slate-900 hover:shadow-sm transition-colors group"
              data-testid={`data-import-${key}-btn`}>
              <Icon size={18} className="text-slate-400 group-hover:text-slate-900 mb-2" />
              <p className="font-semibold text-slate-900">{cfg.label}</p>
              <p className="text-xs text-slate-500 mt-1">{cfg.fields.map((f) => f.label.split(' (')[0]).join(', ')}</p>
              <span className="inline-flex items-center gap-1 text-xs text-sky-700 mt-3"><Upload size={12} /> Import CSV</span>
            </button>
          );
        })}
      </div>
      {kind && <DataImportDialog kind={kind} open={!!kind} onOpenChange={(o) => !o && setKind(null)} />}
    </Card>
  );
}
